@if (data) {
  @if (breadcrumbsComponent) {
    <dotcom-frontend-loader [componentData]="breadcrumbsComponent" />
  }

  @if (disclaimerComponent) {
    <dotcom-frontend-loader [componentData]="disclaimerComponent" />
  }

  @for (item of data["disclaimerPopup"]; let i = $index; track i) {
    <dotcom-frontend-loader [componentData]="item" />
  }

  @if (data["pageTitle"] && data["heroContentArea"].length === 0) {
    <div lgContainer>
      <h1
        class="page-title lg-font--expressive lg-font-size-7 lg-font-size-7--medium"
      >
        {{ data["pageTitle"] }}
      </h1>
    </div>
  }

  @for (item of data["heroContentArea"]; let i = $index; track i) {
    <dotcom-frontend-loader [componentData]="item" />
  }

  @if (data["siteMap"]) {
    <div class="sitemap" lgContainer>
      <div lgRow>
        <div [lgColMdOffset]="2" [lgColMd]="8" [lgColSm]="12">
          <ul class="sitemap__list sitemap__list--primary">
            @for (item of data["siteMap"]; let i = $index; track i) {
              <li>
                @if (item.name) {
                  <dotcom-frontend-link
                    [url]="item.url"
                    class="sitemap__list-block sitemap-title"
                    linkClass="lg-font--expressive lg-font-size-4--medium"
                  >
                    {{ item.name }}
                  </dotcom-frontend-link>
                }

                @if (item.children.length > 0) {
                  <ul class="sitemap__list sitemap__list--primary">
                    @for (child of item.children; let i = $index; track i) {
                      <li class="sitemap__list-block">
                        <dotcom-frontend-link
                          [url]="child.url"
                          class="sitemap__section list-section--title"
                          linkClass="lg-font-size-3"
                        >
                          {{ child.name }}
                        </dotcom-frontend-link>

                        @if (child.children.length > 0) {
                          <ul class="sitemap__list sitemap__list--primary">
                            @for (
                              listItem of child.children;
                              let i = $index;
                              track i
                            ) {
                              <li>
                                <dotcom-frontend-link
                                  [url]="listItem.url"
                                  class="sitemap__section list-section--subtitle"
                                  linkClass="lg-font-size-2--medium"
                                >
                                  {{ listItem.name }}
                                </dotcom-frontend-link>

                                @if (listItem.children.length > 0) {
                                  <ng-container
                                    [ngTemplateOutletContext]="{
                                      $implicit: listItem
                                    }"
                                    [ngTemplateOutlet]="recursiveList"
                                  ></ng-container>
                                }
                              </li>
                            }
                          </ul>
                        }

                        <ng-template #recursiveList let-child>
                          @if (child.children.length > 0) {
                            <ul class="sitemap__list sitemap__list--sublist">
                              @for (
                                listItem of child.children;
                                let i = $index;
                                track i
                              ) {
                                <li class="list-section--page">
                                  <dotcom-frontend-link [url]="listItem.url">
                                    {{ listItem.name }}
                                  </dotcom-frontend-link>

                                  @if (listItem.children.length > 0) {
                                    <ng-container
                                      [ngTemplateOutletContext]="{
                                        $implicit: listItem
                                      }"
                                      [ngTemplateOutlet]="recursiveList"
                                    ></ng-container>
                                  }
                                </li>
                              }
                            </ul>
                          }
                        </ng-template>
                      </li>
                    }
                  </ul>
                }
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
  }
}
